<template>
    <v-card class="px-3 py-5 grey lighten-5">
        <table v-if="$vuetify.breakpoint.smAndUp && spielerFoto">
            <tr>
                <td class="pr-5">
                    <img :src="spielerFoto" width="150px">
                    <v-btn v-if="$store.state.user.permissions.pass"
                           block color="primary" small @click="downloadWithVueResource()">herunterladen</v-btn>
                </td>
                <td>
                    <div v-if="fieldList">
                        <v-row>
                            <v-col v-for="(field, i) in fieldList" :key="i"
                                   :cols="field.cols ? $vuetify.breakpoint.xsOnly ? 12 : field.cols : 12"
                                   class="px-4 py-0">
                                <info-line :header="field.app">
                                    <span v-if="field.childOf === ''">{{getValueOrPlaceholder(dataObject[field.id])}}</span>
                                    <span v-else>{{getValueOrPlaceholder(dataObject[field.childOf][field.id])}}</span>
                                </info-line>
                            </v-col>
                        </v-row>
                    </div>
                </td>
            </tr>
        </table>
        <div v-else>
            <div v-if="spielerFoto" class="text-center mb-8">
                <img :src="spielerFoto" width="120px">
                <br>
                <v-btn v-if="$store.state.user.permissions.pass"
                       color="primary" small @click="downloadWithVueResource()">herunterladen</v-btn>
            </div>
            <div v-if="fieldList">
                <v-row>
                    <v-col v-for="(field, i) in fieldList" :key="i"
                           :cols="field.cols ? $vuetify.breakpoint.xsOnly ? 12 : field.cols : 12"
                           class="px-4 py-0">
                        <info-line :header="field.app">
                            <span v-if="field.childOf === ''">{{getValueOrPlaceholder(dataObject[field.id])}}</span>
                            <span v-else>{{getValueOrPlaceholder(dataObject[field.childOf][field.id])}}</span>
                        </info-line>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-card>
</template>

<script>
    import {Spieler} from "@/services/data/spieler/spieler";
    import InfoLine from "../../../components/elements/infoLine";
    import SpielService from "@/services/data/spielService";

    export default {
        components: {InfoLine},
        name: "spieler-data",
        props: ['spieler'],
        data: () => ({
            dataObject: null,
            imgSrc: '',
            fieldList: [],
        }),
        created(){
            this.setFieldList();
        },
        computed: {
            spielerFoto(){
                return this.spieler && this.spieler.url ?
                    this.$store.state.config.storage.passfotos + this.spieler.id + '.jpeg?' + this.spieler.url :
                    ''
            }
        },
        methods: {
            setFieldList(){
                this.dataObject = new Spieler();
                this.dataObject.setFromDataObject(this.spieler);
                this.fieldList = this.getAdaptedFieldList()
                this.dataObject.setCurrentData(this.spieler);
                this.dataObject.ak = this.getAltersklasse(this.spieler)
            },
            getAdaptedFieldList(){
                const fieldList = JSON.parse(JSON.stringify(this.dataObject.getFieldListEdit('info'))) ;
                const titel = fieldList.find(field => field.id === 'titel')
                titel.cols = 1
                const nachname = fieldList.find(field => field.id === 'nachname')
                nachname.cols = 3
                const geschlecht = fieldList.find(field => field.id === 'geschlecht')
                geschlecht.cols = 2
                return fieldList
            },
            getValueOrPlaceholder(value){
                return value ? value : '-'
            },
            getAltersklasse(spieler){
                if ( !spieler.dates?.akHJ ) { return 'unbekannt' }
                return SpielService.getAltersklasse(spieler.dates.akHJ,
                    spieler.dates.akJahr, '1_1_'+ this.$store.state.local.sportJahr.current.id, spieler.sportart)
            },

            downloadWithVueResource() {
                this.$http({
                    method: 'get',
                    url: this.spielerFoto,
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        this.forceFileDownload(response)
                    })
                    .catch(() => console.log('error occured'))

            },
            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.spieler.nachname + '_' + this.spieler.vorname + '.jpg'); //or any other extension
                document.body.appendChild(link);
                link.click()
            },
        },
        watch: {
            spieler: {
                handler(){
                    this.setFieldList();
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>